import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

export const FormInputDropdown = ({
  name,
  label,
  options,
  errors,
  required,
  styles,
  disabled = false,
  control,
}) => {
  const ocontrol = useFormContext();

  const dcontrol = control || ocontrol;

  const generateSingleOptions = () => {
    return options?.map((option) => {
      return (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            fontSize: "1rem",
            minHeight: "48px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
            "&.Mui-selected": {
              backgroundColor: "rgba(25, 118, 210, 0.12)",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "rgba(25, 118, 210, 0.2)",
              },
            },
          }}
        >
          {option.label}
        </MenuItem>
      );
    });
  };

  return (
    <FormControl
      variant="outlined"
      sx={{ marginBottom: 5, marginTop: 5, ...styles }}
      error={!!errors[name]}
    >
      <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
      <Controller
        rules={{
          required: {
            value: !!required,
            message: `${name} is required`,
          },
        }}
        render={({ field }) => (
          <Select
            label={label}
            disabled={disabled}
            id="demo-simple-select-outlined"
            labelId="demo-simple-select-outlined-label"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  mt: 0.5,
                  boxShadow: "0px 5px 15px rgba(0,0,0,0.15)",
                  borderRadius: 1,
                },
              },
            }}
            {...field}
            value={field.value ?? ""}
          >
            {generateSingleOptions()}
          </Select>
        )}
        name={name}
        control={dcontrol}
      />
      <FormHelperText>{errors[name]?.message}</FormHelperText>
    </FormControl>
  );
};
